import React, { Component } from "react";
import styled, { keyframes } from "styled-components";
import { fadeIn } from "react-animations";
import PageHeaderSimple from "./simple-accessories/PageHeaderSimple";
import { PageSliderComponent } from "./simple-accessories/PageSliderComponent";
import PageFooter from "../multi-page-attributes/PageFooter";

const FadeIn = styled.div`animation: 2s ${keyframes`${fadeIn}`}`;

export default class SimplePageManager extends Component {
    render() {
        return (
            <>
                <PageHeaderSimple />
                <FadeIn>
                    <div style={{
                        margin: "auto",
                        paddingTop: "2%",
                        paddingLeft: "2.5%",
                        paddingRight: "2.5%",
                        paddingBottom: "1%",
                    }}>
                        <PageSliderComponent />
                    </div>
                </FadeIn>
                <PageFooter />
            </>
        );
    }
}
